<template>
    <div class="card-container">
        <common-top-form :model="formModel" :submitService="submitService" :show="false" :submitData="submitData"
                         @success="onSuccess" buttonName="导出">
            <el-form-item label="所属机构">
                <el-select v-model="formModel.tatSimpleId">
                    <el-option
                        v-for="item in topTatSimpleNames"
                        :key="item.id"
                        :label="item.simpleName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="注册账号">
                <el-input v-model="formModel.account" maxlength="20" placeholder="请输入注册账号"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
                <el-input v-model="formModel.realName" maxlength="20" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="卡ID">
                <el-input v-model="formModel.cardId" maxlength="50" placeholder="请输入卡ID"></el-input>
            </el-form-item>
            <el-form-item label="信用卡号">
                <el-input v-model="formModel.cardNo" maxlength="50" placeholder="请输入信用卡号"></el-input>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getList">
            <el-table-column prop="tatName" label="机构名称" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="account" label="注册账号" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="realName" label="真实姓名" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cardId" label="卡ID" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="cardNo" label="信用卡号" width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{doUnicode(scope.row.cardNo)}}</p>
                </template>
            </el-table-column>
            <!--<el-table-column prop="cvv2" label="CVV码" show-overflow-tooltip></el-table-column>-->
            <!--<el-table-column prop="limitDt" label="有效期" show-overflow-tooltip></el-table-column>-->
            <el-table-column prop="mobile" label="预留手机号" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="注册时间" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="payTypeName" label="通道名称" show-overflow-tooltip></el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'

    import RongBaoService from 'service/RongBaoService'
    import OrganService from 'service/OrganService'
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {mapGetters} from 'vuex'

    export default {
        name: "rongbaobind",
        components: {
            CommonTopForm, CommonTable
        },
        data() {
            return {
                formModel: {
                    tatSimpleId:'',
                    account: '',
                    realName: '',
                    cardId: '',
                    cardNo: '',
                },
                tatSimpleNames:[],
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                topTatSimpleNames: [],
                tableData: [],
                page:{},
                submitService:RongBaoService.bindList,
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        computed:{
            submitData(){
                const params = {
                    account : this.formModel.account.trim(),
                    realName : this.formModel.realName.trim(),
                    cardId : this.formModel.cardId.trim(),
                    cardNo : this.formModel.cardNo.trim(),
                    current:this.page.currentPage,
                    size:this.page.pageSize,
                    tatSimpleId:this.formModel.tatSimpleId,
                };
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getSimpleNames();
            this.getList();
        },
        methods: {
            getSimpleNames() {
                this.doLoad(OrganService.simpleNames, '', res => {
                    this.doCheck(res, res => {
                        this.tatSimpleNames = res.contents;
                        this.topTatSimpleNames = [...this.all, ...res.contents];
                    });
                }, '信息获取失败')
            },
            onSuccess(data){
                this.doCheck(data, data => {
                    const result = data.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.pageSize = result.size;
                    this.page.total = result.total;
                })
            },
            getList(){
                this.doLoad(RongBaoService.bindList, this.submitData, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.pageSize = result.size;
                        this.page.total = result.total;
                    })
                }, '信息获取失败')
            },

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/RongBaoManage/RongBaoBind.vue